<template>
<div class="RandomTiles-MAIN" ref="tilesGrid">

    <img v-for="(item, index) in artworks" :key="index"
        :src="thumbnailSrc(item.file)"
        @error="useOriginalArtworkImage($event, item.file)"
        loading="lazy"
        @click="viewArtworkCard(item.id)"
    />
        
</div>
</template>

<script>
export default {
    name: 'RandomTiles',
    props: {
        artworks: Array,
    },
    data(){
        return{

        }
    },
    methods: {
        renderTiles(){
            const grid = this.$refs.tilesGrid;
            if (!grid) return;

            const n = this.artworks.length;
            const squareSize = Math.ceil(Math.sqrt(n));

            const cell = "calc(33.3vw - 6vw)";

            grid.style.display = "grid";
            grid.style.gridTemplateColumns = `repeat(${squareSize}, ${cell})`;
            grid.style.gridTemplateRows = `repeat(${squareSize}, ${cell})`;
            grid.style.gridAutoRows = cell;        // clave para Safari
            grid.style.gridAutoColumns = cell;     // (opcional)
            grid.style.gap = "3vw";
            grid.style.justifyItems = "stretch";
            grid.style.alignItems = "stretch";
            grid.style.gridAutoFlow = "dense";

            const imgs = grid.querySelectorAll("img");
            imgs.forEach(img => {
                const colSpan = Math.random() < 0.3 ? 2 : 1;
                const rowSpan = Math.random() < 0.3 ? 2 : 1;

                // Forma más compatible:
                img.style.gridArea = `span ${rowSpan} / span ${colSpan}`;

                // (alternativa equivalente)
                img.style.gridColumn = `auto / span ${colSpan}`;
                img.style.gridRow = `auto / span ${rowSpan}`;
            });
        },

        thumbnailSrc(file) {
            const baseName = file.split('.').slice(0, -1).join('.');
            return `${this.$ENDPOINT}/assets/thumbnails_artworks/${baseName}.webp`;
        },

        useOriginalArtworkImage(event, file) {
            event.target.onerror = null;
            event.target.src = `${this.$ENDPOINT}/assets/artworks/${file}`;
        },

        viewArtworkCard(id){
            this.$router.push({ name: 'artworkcard', params: { id: String(id) } });
        },
    },
    mounted(){
        this.renderTiles();
    }
}
</script>

<style scoped lang="stylus">
.RandomTiles-MAIN
    margin-bottom: 20vh
    width: fit-content

    >img
        width: 100%
        height: 100%
        object-fit: cover
        object-position: center
        border-radius: 5vw
</style>